import { LeadsPage } from '@/features/leads/leads-page'
import { LinkedInRequiredGate } from '@/components/linkedin-required-gate'

export default function LeadsPageRoute() {
  return (
    <LinkedInRequiredGate
      featureName="Leads"
      description="Lead pipeline, ICP scoring, and discovery all run against your connected LinkedIn account. Connect one to start tracking prospects."
    >
      <LeadsPage />
    </LinkedInRequiredGate>
  )
}
